import {useState,useEffect} from 'react'
import axios from '../../../axios'
const CourseDropdown = ({value,handleInputChange,dont,imp,orders,yes}) => {
    const [centres, setCentres] = useState([]);
  const[err,setErr]=useState(false)
//console.log(value)
    useEffect(() => {
      const fetchCentres = async () => {

        try {
          const response = await axios.get('/trainingcentre/getIdName');
          setCentres(response.data.centres);
        } catch (error) {
          setErr(true)
          console.error('Error fetching centres:', error);
        }
      };
  
      fetchCentres();
    }, []);
  
    return (
      <div>
        <label className={`block ${orders?'mt-3 mb-4':'mb-2'} text-sm font-medium text-gray-900 dark:text-white`} htmlFor="course-code">
          Centre Name
        </label>
        <select
          id="course-code"
          value={value}
          disabled={dont}
          onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        > 
          <option value="" >All</option>
          {centres.map((centre) => (
            <option key={centre.centre_id} value={centre.centre_id}>
              {centre.centre_name}
            </option>
          ))}
        </select>
      </div>
    );
  };
  
  export default CourseDropdown;